



































































































































import Vue from 'vue'
import { State, Action, Getter } from "vuex-class";
import { Component, Prop, Watch } from "vue-property-decorator";
import DateComponent from '@/components/common/Inputs/Date.vue';
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import { Utilities as utils } from "@/shared/utilities";
import { FinReportConsolidation } from '@/entities';
import { Locales } from "@/i18n/locales";
const namespace: string = "financialReport";

@Component({
    components: {
        DateComponent,
        FormattedNumber,
        VCurrencyField
    }
})
export default class ConsolidationTable extends Vue {
    @Prop() header: any;
    @Prop() item: FinReportConsolidation;
    @Prop() currencyList: any;
    @Prop() grantInfo: any;
    @Prop() categories: Array<any>;
    @Prop() currency: string;
    @Prop() formOptions: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    searchString = '';

    /** calcualte summary field on change */
    aggregate() {
        this.item.totalCredited = ( (this.item.balanceAtBeginning || 0) + (this.item.fundInflow || 0) + (this.item.creditInterest || 0) );
        this.item.balance = this.item.totalCredited - (this.item.totalExpenditure ?? 0);
        this.item.replenishAmount = (this.item.forecast ?? 0) - this.item.balance;

        this.$emit('input', true);
    }
    
}
